<template>
  <strong class="flex items-center gap-050 h-300">
    <template v-if="remaining <= 0">
      <Transition appear name="bounce-md">
        <div class="icon-done w-300 h-300 rounded-l">
          <LcIcon name="checkmark-small" />
        </div>
      </Transition>

      <slot name="done" />
    </template>

    <slot v-else />
  </strong>
</template>

<script lang="ts" setup>
type Props = { remaining: number }
defineProps<Props>()
</script>

<style lang="scss" scoped>
.icon-done {
  background-color: token('color/background/accent/success/success');
  color: token('color/icon/primary/primary');
}
</style>
